import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createPayment, getUserById, updateUser } from '../../Redux/Actions/actions';
import { useParams, useNavigate } from 'react-router-dom';
import styles from './EditUser.module.css';

const EditUser = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();

  const { user, userLoading, userError } = useSelector(state => state);
  const [editingCuota, setEditingCuota] = useState(false);

  const [formData, setFormData] = useState({
    dni: '',
    name: '',
    last_name: '',
    email: '',
    phone_number: '',
    birth_date: '',
    gender: '',
    address: '',
    emergency_contact_name: '',
    emergency_contact_phone: '',
    cuotaPaga: false,
    cuota_vencimiento: '',
    monday: false,
    tuesday: false,
    wednesday: false,
    thursday: false,
    friday: false,
    saturday: false,
    sunday: false,
    status: false,
    observations: '',
    photo: '',
    registration_date: ''
  });

  const [paymentData, setPaymentData] = useState({
  amount: '',
  payment_method: '',
  notes: ''
});

const handlePagarCuota = () => {
  setEditingCuota(true);
  const currentDate = new Date(formData.cuota_vencimiento || new Date());
  currentDate.setMonth(currentDate.getMonth() + 1);
  const newDate = currentDate.toISOString().split('T')[0];
  setFormData(prev => ({
    ...prev,
    cuota_vencimiento: newDate,
    cuotaPaga: true
  }));
};


  useEffect(() => {
    dispatch(getUserById(id));
  }, [dispatch, id]);

useEffect(() => {
  if (user && user.length > 0) {
    const u = user[0];
    setFormData({
      dni: u.dni || '',
      name: u.name || '',
      last_name: u.last_name || '',
      email: u.email || '',
      phone_number: u.phone_number || '',
      birth_date: u.birth_date ? u.birth_date.split('T')[0] : '',
      gender: u.gender || '',
      address: u.address || '',
      emergency_contact_name: u.emergency_contact_name || '',
      emergency_contact_phone: u.emergency_contact_phone || '',
      cuotaPaga: u.cuotaPaga || false,
      cuota_vencimiento: u.cuota_vencimiento ? u.cuota_vencimiento.split('T')[0] : '',
      monday: u.monday || false,
      tuesday: u.tuesday || false,
      wednesday: u.wednesday || false,
      thursday: u.thursday || false,
      friday: u.friday || false,
      saturday: u.saturday || false,
      sunday: u.sunday || false,
      status: u.status || false,
      observations: u.observations || '',
      photo: u.photo || '',
      registration_date: u.registration_date ? u.registration_date.split('T')[0] : ''
    });
  }
}, [user]);

console.log('User from Redux:', user);

  console.log(formData);
  

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

const handleSubmit = async (e) => {
  e.preventDefault();

  // Siempre actualiza los datos del usuario
  await dispatch(updateUser(id, formData));

  // Si se pagó la cuota, registra el pago
  if (editingCuota) {
    await dispatch(createPayment({
      userId: id,
      amount: paymentData.amount,
      payment_method: paymentData.payment_method,
      notes: paymentData.notes
    }));

    // Opcional: refrescar los datos del usuario para ver los cambios actualizados en la UI
    await dispatch(getUserById(id));
  }

  navigate('/users');
};


  if (userLoading) return <p>Cargando usuario...</p>;
  if (userError) return <p className={styles.error}>{userError}</p>;
  if (!user) return <p>Usuario no encontrado</p>;

  return (
  <div className={styles.container}>
  <form className={styles.form} onSubmit={handleSubmit}>
    <h2>Editar Usuario</h2>

    <label className={styles.label} htmlFor="dni">DNI</label>
    <input
      id="dni"
      name="dni"
      placeholder="DNI"
      value={formData.dni}
      onChange={handleChange}
      required
    />

    <label className={styles.label} htmlFor="name">Nombre</label>
    <input
      id="name"
      name="name"
      placeholder="Nombre"
      value={formData.name}
      onChange={handleChange}
      required
    />

    <label className={styles.label} htmlFor="last_name">Apellido</label>
    <input
      id="last_name"
      name="last_name"
      placeholder="Apellido"
      value={formData.last_name}
      onChange={handleChange}
      required
    />

    <label className={styles.label} htmlFor="email">Email</label>
    <input
      id="email"
      name="email"
      placeholder="Email"
      value={formData.email}
      onChange={handleChange}
      required
    />

    <label className={styles.label} htmlFor="phone_number">Teléfono</label>
    <input
      id="phone_number"
      name="phone_number"
      placeholder="Teléfono"
      value={formData.phone_number}
      onChange={handleChange}
      required
    />

    <label className={styles.label} htmlFor="birth_date">Fecha de nacimiento</label>
    <input
      id="birth_date"
      name="birth_date"
      type="date"
      placeholder="Fecha de nacimiento"
      value={formData.birth_date}
      onChange={handleChange}
      required
    />

    <label className={styles.label} htmlFor="gender">Género</label>
    <select
      id="gender"
      name="gender"
      value={formData.gender}
      onChange={handleChange}
      required
    >
      <option value="">Género</option>
      <option value="Femenino">Femenino</option>
      <option value="Masculino">Masculino</option>
      <option value="Otro">Otro</option>
    </select>

    <label className={styles.label} htmlFor="address">Dirección</label>
    <input
      id="address"
      name="address"
      placeholder="Dirección"
      value={formData.address}
      onChange={handleChange}
      required
    />

    <label className={styles.label} htmlFor="emergency_contact_name">Contacto de emergencia</label>
    <input
      id="emergency_contact_name"
      name="emergency_contact_name"
      placeholder="Contacto de emergencia"
      value={formData.emergency_contact_name}
      onChange={handleChange}
      required
    />

    <label className={styles.label} htmlFor="emergency_contact_phone">Teléfono de emergencia</label>
    <input
      id="emergency_contact_phone"
      name="emergency_contact_phone"
      placeholder="Teléfono de emergencia"
      value={formData.emergency_contact_phone}
      onChange={handleChange}
      required
    />

    <label className={styles.label}>Cuota paga</label>
    <label className={styles.checkboxLabel}>
      <input
        type="checkbox"
        name="cuotaPaga"
        checked={formData.cuotaPaga}
        onChange={handleChange}
      />
      Cuota paga
    </label>

    <label className={styles.label}>Vencimiento de cuota</label>
<div style={{ display: 'flex', alignItems: 'center', gap: '10px', flexDirection: 'column' }}>
  <input
    id="cuota_vencimiento"
    name="cuota_vencimiento"
    type="date"
    value={formData.cuota_vencimiento}
    readOnly={!editingCuota}
    onChange={handleChange}
  />

  {!editingCuota && (
    <button type="button" onClick={handlePagarCuota}>
      Pagar cuota
    </button>
  )}
</div>

  {editingCuota && (
  <div className={styles.paymentBox}>
    <h3>Registrar Pago de Cuota</h3>

    <label className={styles.label} htmlFor="amount">Monto</label>
    <input
      id="amount"
      name="amount"
      type="number"
      value={paymentData.amount}
      onChange={(e) => setPaymentData({ ...paymentData, amount: e.target.value })}
      required
    />
    

    <label className={styles.label} htmlFor="payment_method">Método de pago</label>
    <input
      id="payment_method"
      name="payment_method"
      placeholder="Efectivo, transferencia, etc."
      value={paymentData.payment_method}
      onChange={(e) => setPaymentData({ ...paymentData, payment_method: e.target.value })}
      required
    />

    <label className={styles.label} htmlFor="notes">Notas</label>
    <input
      id="notes"
      name="notes"
      placeholder="Notas opcionales"
      value={paymentData.notes}
      onChange={(e) => setPaymentData({ ...paymentData, notes: e.target.value })}
    />
<h1></h1>
    <button
      type="button"
      onClick={() => {
        setEditingCuota(false);
        setPaymentData({ amount: '', payment_method: '', notes: '' });
        dispatch(getUserById(id)); // Para revertir cuota_vencimiento y cuotaPaga
      }}
      className={styles.cancelButton}
    >
      Cancelar pago
    </button>
  </div>
)}



    <label className={styles.label}>Días de asistencia</label>
    <div className={styles.days}>
      <label><input type="checkbox" name="monday" checked={formData.monday} onChange={handleChange} />Lunes</label>
      <label><input type="checkbox" name="tuesday" checked={formData.tuesday} onChange={handleChange} />Martes</label>
      <label><input type="checkbox" name="wednesday" checked={formData.wednesday} onChange={handleChange} />Miércoles</label>
      <label><input type="checkbox" name="thursday" checked={formData.thursday} onChange={handleChange} />Jueves</label>
      <label><input type="checkbox" name="friday" checked={formData.friday} onChange={handleChange} />Viernes</label>
      <label><input type="checkbox" name="saturday" checked={formData.saturday} onChange={handleChange} />Sábado</label>
      <label><input type="checkbox" name="sunday" checked={formData.sunday} onChange={handleChange} />Domingo</label>
    </div>

    <label className={styles.label} htmlFor="observations">Observaciones</label>
    <input
      id="observations"
      name="observations"
      placeholder="Observaciones"
      value={formData.observations}
      onChange={handleChange}
    />

    <label className={styles.label} htmlFor="photo">URL de foto</label>
    <input
      id="photo"
      name="photo"
      placeholder="URL de foto"
      value={formData.photo}
      onChange={handleChange}
    />

    <label className={styles.label} htmlFor="registration_date">Fecha de alta</label>
    <input
      id="registration_date"
      name="registration_date"
      type="date"
      placeholder="Fecha de alta"
      value={formData.registration_date}
      onChange={handleChange}
      required
    />

    <button type="submit" disabled={userLoading}>
      {userLoading ? 'Guardando...' : 'Guardar socio'}
    </button>
    {userError && <p className={styles.error}>{userError}</p>}
  </form>
</div>

  );
};

export default EditUser;
